import React, { useEffect, useState } from 'react';
import Popover from 'screens/shared/popover';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { ClickAwayListener } from '@mui/material';
import { sleep, _t } from 'utils';
import Shared from 'screens/shared';
import { RESOURCE_TYPE, ROUTE } from 'constant';
import {
  loadGraph, generateLanNodes, generateServerNodes, getServerId, getNodeIdFromDom, addNodeStatus,
} from './graph-service';
import Server from './server';

let graphInstance = null;

export default ({ match }) => {
  const { dcId } = match.params;
  const [isGraphLoaded, setIsGraphLoaded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  const { screen = {}, [ACTIONS_TYPES.DATA_CENTER.GET]: selectedDataCenter = {}, selectedServer = {} } = useSelector((e) => e);
  const { width = '100%', height = '100vh' } = screen;
  const { entities = {}, properties = {} } = selectedDataCenter;
  const { servers = {}, lans = {} } = entities;

  const { items: serverItems = [] } = servers;
  const { items: lansItems = [] } = lans;
  // const { items: volumesItems = [] } = volumes;

  const nodes = [
    ...generateServerNodes({ serverItems }),
    ...generateLanNodes({ lansItems, serverItems }),
  ];

  const findNodeId = (_objId) => {
    const node = nodes.find(({ objId }) => objId === _objId) || {};
    return node.id;
  };

  let links = [...lansItems.map(({ id, entities: innerEntities }) => (
    { id, servers: innerEntities.nics.items.map(({ href }) => getServerId(href)) }
  ))];
  links = links.map((link) => link.servers.map((serverId) => ({ from: link.id, to: serverId })));
  links = [].concat(...links);
  links = links.map(({ from, to }) => ({
    source: findNodeId(from),
    target: findNodeId(to),
  }));

  useEffect(() => {
    loadGraph().then(() => setIsGraphLoaded(true));
    actions.dataCenter.get({ id: dcId });

    return () => {
      if (graphInstance) {
        graphInstance.clear();
        document.querySelector('.n-topology').remove();
      }
    };
  }, [dcId]);

  useEffect(() => {
    if (properties.name) {
      actions.common.setLayoutTitle({
        layout: { title: properties.name, menu: ROUTE.DASHBOARD.DATA_CENTERS.key },
      });
    }
  }, [properties.name]);

  useEffect(() => {
    if (isGraphLoaded && properties.name) {
      const { nx } = window;
      const nodeConfig = {
        label: 'model.name',
        iconType: 'model.icon',
        color: '#000',
      };

      const graphConfig = {
        width: width < 600 ? width : width - 250,
        height,
        showIcon: true,
        nodeConfig,
        nodeSetConfig: nodeConfig,
        linkConfig: {
          linkType: 'parallel',
        },
        dataProcessor: 'quick',
      };

      graphInstance = new nx.graphic.Topology(graphConfig);
      graphInstance.on('click', (_, event) => {
        const targetDom = event.target;
        const nodeId = getNodeIdFromDom(targetDom);
        if (nodeId) {
          setSelectedNode(nodes.find(({ id }) => id.toString() === nodeId));
          sleep(50).then(() => setAnchorEl(targetDom));
        }
      });
      graphInstance.attach(new nx.ui.Application());
      graphInstance.data({
        nodes,
        links,
      });
      addNodeStatus({ graphInstance });
      window.graphInstance = graphInstance;
    }
    // eslint-disable-next-line
  }, [isGraphLoaded, properties.name]);

  useEffect(() => {
    if (selectedNode) {
      if (selectedNode?.type === RESOURCE_TYPE.SERVER) actions.server.get({ dcId, id: selectedNode?.id });
    }
    // eslint-disable-next-line
  }, [selectedNode]);

  return (
    <div>
      <h1>{_t('Loading...')}</h1>
      {!!anchorEl && (
        <Popover
          anchorEl={anchorEl}
          render={(
            <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
              <div>
                <Shared.widgets.Loader
                  action={ACTIONS_TYPES.DATA_CENTER.GET_SERVER}
                  size={32}
                  isInline
                />
                {selectedServer.id && (
                  <Server server={selectedServer} />
                )}
              </div>
            </ClickAwayListener>
          )}
          className="screen-graph-modal"
        />
      )}
    </div>
  );
};
